import Calendar from '../../spa/calendar/Calendar';

export default {
  path: 'calendar',
  name: 'calendar',
  component: Calendar,
};



// WEBPACK FOOTER //
// ./src/config/router/calendar.js